module.exports = __webpack_public_path__ + "img/filter.55157665.svg";